<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">
          Runs
        </h1>
      </template>
      <template #actions>
        <page-header-action tag="router-link" to="/runs/create">
          New Run
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="loading-overlay" v-if="loading"></div>
          <div class="card-header">
            <div style="width: 100%; margin: 0;">
              <div class="row">
                <div class="col">
                  <selectlist
                    name="handler_id"
                    label="Driver"
                    label-name="full_name"
                    :options="drivers"
                    :value="filters.driver_id"
                    @input="setDriver"
                    :stacked="true"
                  ></selectlist>
                </div>

                <div class="col">
                  <label class="control-label">Status</label>
                  <select
                    class="form-control"
                    name="status"
                    :value="filters.complete"
                    @input="setStatus"
                  >
                    <option value="">Please Select</option>
                    <option value="0">Incomplete</option>
                    <option value="1">Completed</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Driver</th>
                  <th>Date</th>
                  <th>Jobs</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody v-if="!!runs && runs.length">
                <tr v-bind:key="index" v-for="(run, index) in runs">
                  <td>
                    {{ run.driver?.full_name || 'Not Assigned' }}
                  </td>
                  <td>
                    {{ run.start_date | date }}
                    <span v-if="run.end_date"
                      >to {{ run.end_date | date }}</span
                    >
                  </td>
                  <td>
                    {{ run.items?.length || 0 }}
                  </td>
                  <td class="text-right">
                    <router-link
                      class="btn btn-primary"
                      :to="`/runs/${run.identifier}/edit`"
                    >
                      Edit Run
                    </router-link>
                    <form-button
                      :indicator="run.indicator"
                      level="danger"
                      v-if="hasPermission('runs.delete')"
                      v-on:clicked="archive(run)"
                    >
                      Archive
                    </form-button>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!runs.length">
                <tr>
                  <td colspan="4" class="text-center">
                    No results found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="card-footer text-right" v-show="showPagination">
            <pagination
              :data="paginator_data"
              v-on:updateResults="getData"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  components: {
    PageHeader,
    PageHeaderAction
  },

  data() {
    return {
      loading: false,
      runs: [],
      paginator_data: {},
      filters: {
        driver_id: null,
        complete: '0',
        date: null
      },
      archiveIndicator: false
    };
  },

  computed: {
    drivers() {
      return this.$store.getters['ClaimHandlers/drivers'];
    },

    showPagination() {
      return (
        this.paginator_data.next_page_url || this.paginator_data.prev_page_url
      );
    }
  },

  mounted() {
    this.$store.commit('ClaimHandlers/retrieve');

    this.getRuns();
  },

  methods: {
    getRuns() {
      this.getData(`/runs?per_page=${this.perPage}`);
    },

    getData(url) {
      Object.keys(this.filters).forEach(key => {
        url = `${url}&filter[${key}]=${this.filters[key] || ''}`;
      });

      this.loading = true;

      window.Ajax.get(`${url}&sort=-start_date&parts=driver`)
        .then(response => {
          this.runs = response.data.data;
          this.paginator_data = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },

    setDriver(driver) {
      this.filters.driver_id = driver;

      this.getRuns();
    },

    setStatus(event) {
      this.filters.complete = event.target.value;

      this.getRuns();
    },

    archive(run) {
      window
        .swal({
          title: 'Please Confirm',
          text: 'Are you sure you want archive this run?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        })
        .then(() => {
          run.indicator = true;

          window.Ajax.delete(`/runs/${run.identifier}`)
            .then(response => {
              run.indicator = false;
              window.toastify.success(
                'Archived',
                'The run was archived successfully!'
              );
              this.getRuns();
            })
            .catch(error => {
              window.toastify.error(
                'Error',
                'Sorry, there was an error archiving the run'
              );

              run.indicator = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>
